export enum AssessmentKeys {
  adminGetAllAssessment = "admin-get-all-assessment",
  adminGetAssessment = "admin-get-assessment",
  adminCreateAssessment = "admin-create-assessment",
  adminUpgradeStaff = "admin-upgrade-staff",
}
